
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Story',
	'noDashboardFound': 'Die Story kann nicht abgerufen werden. Sie ist entweder nicht mehr vorhanden oder Sie verfügen nicht über ausreichende Berechtigungen für die Anzeige.',
	'noDashboardCapability': 'Sie verfügen nicht über die Funktion zur Verwendung von Storys.',
	'noDashboardPermision': 'Sie verfügen nicht über ausreichende Berechtigungen zum Anzeigen dieser Story.',
	'defaultName': 'Neue Story',
	'storyProperties': 'Storyeigenschaften',
	'createAvDataStoryLabel': 'Story',
	'createAvSlideShowLabel': 'Präsentation',
	'createAvPanAndZoomLabel': 'Menügeführte Tour',
	'dashboard_save_success': 'Die Story wurde gespeichert.',
	'cmEmptySelection': 'Die Story wurde gelöscht. Speichern Sie die Daten als neue Story.',
	'createStoryTitle': 'Story erstellen',
	'transitionStyleTitle': 'Übergangsstil',
	'createButton': 'Erstellen',
	'cancelButton': 'Abbrechen',
	'dashboardResetTitle': 'Story zurücksetzen',
	'dashboardResetMessage': 'Sollen alle für diese Story angewendeten Änderungen tatsächlich zurückgesetzt werden?',
	'dashboardResetToast': 'Die Story wurde zurückgesetzt.',
	'filter_drag_and_drop_all_tabs': 'Daten hierher ziehen und ablegen, um alle Szenen zu filtern.',
	'filter_drag_and_drop_current_tab': 'Daten hierher ziehen und ablegen, um diese Szene zu filtern.',
	'filterIconLabel_Global': 'Alle Szenen',
	'filterIconLabel_Tab': 'Diese Szene',
	'filterIconTooltip_Global': 'Alle Szenen',
	'filterIconTooltip_Tab': 'Diese Szene',
	'filterOverflowMenu_Global': 'Alle Szenen - Überlaufmenü',
	'filterOverflowMenu_Tab': 'Diese Szene - Überlaufmenü',
	'renameScene': 'Szene umbenennen',
	'duplicateScene': 'Szene duplizieren',
	'deleteScene': 'Szene löschen',
	'editTimelineHighlight': 'Hervorhebung bearbeiten',
	'deleteTimelineHighlight': 'Hervorhebung löschen',
	'filter_includesAll': 'Alles einbeziehen',
	'timeline_highlight_moved_to': 'Zeitachsenhervorhebung %{id} nach %{time} verschoben',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Auswählen',
	'newDefaultStoryName': 'Story: %{modelName}',
	'exportLabel': 'Speichern',
	'exportAsLabel': 'Speichern unter:',
	'exportDialogTitle': 'Als Story speichern',
	'exportDialogFooter': 'Schaltflächen für Speichern und Abbrechen',
	'loadAfterExportLabel': 'Story nach dem Speichern öffnen',
	'selectTemplateLabel': 'Vorlage auswählen',
	'outOfBoundsWarningMessage': 'Einige Dashboard-Widgets befinden sich außerhalb des Rasters und werden nach dem Export möglicherweise nicht korrekt angezeigt.',
	'emptyExploreCardsWarningMessage': 'Beim Speichern als Story wurden leere Karten gelöscht.',
	'dashboard_export_success': 'Das Dashboard wurde erfolgreich als Story gespeichert.',
	'explore_export_success': 'Die Exploration wurde erfolgreich als Story gespeichert.',
	'toastUpgradeDone': 'Für die Story wurde ein Upgrade durchgeführt. Jetzt speichern, um eine optimale Leistung zu erhalten.',
	'navigationMarker': 'Navigation - Datenpunkt',
	'navigateMarkers': 'Navigation - Datenpunkte',
	'navNextMarker': 'Nächster Datenpunkt',
	'navPrevMarker': 'Vorheriger Datenpunkt',
	'navPrevMarkerAbbreviated': 'Vorheriger Datenpunkt',
	'timelineSettingsButton': 'Wiedergabeoptionen',
	'autoPlay': 'Alle Szenen wiedergeben',
	'loop': 'Wiederholte Wiedergabe',
	'refreshData': 'Beim Start aktualisieren',
	'slideshowLabel': 'Präsentation',
	'panAndZoomLabel': 'Menügeführte Tour',
	'slideShowLayoutLabel': 'Präsentationslayout',
	'panAndZoomLayoutLabel': 'Layout einer menügeführten Tour',
	'panAndZoomLayoutFooter': 'Das Layout einer menügeführten Tour ist eine Gruppe von Szenen in einem einzelnen Erstellungsbereich. Bei der Ausführung einer Story dieses Typs werden die einzelnen Szenen der Reihe nach mithilfe von Verschiebungs-/Zoomaktionen dargestellt. Damit unterscheidet sich dieses Layout von einem Präsentationslayout, bei dem jede Szene in einem neuen Erstellungsbereich dargestellt wird. Das Layout einer menügeführten Tour mit drei Szenen, die durch Linien verbunden sind, ermöglicht die Erstellung einer horizontalen Abfolge von Szenen. Dies ist zur Darstellung einer Zeitachse nützlich.',
	'PanAndZoomLayout1': '5 im Rechteck angeordnete Szenen',
	'PanAndZoomLayout2': '4 von links nach rechts aufsteigend gestaffelte Szenen',
	'PanAndZoomLayout3': '6 im Rechteck angeordnete Szenen',
	'PanAndZoomLayout4': '7 im Rechteck angeordnete Szenen, wobei 6 kleine Szenen oben und 1 große Szene unten dargestellt sind',
	'PanAndZoomLayout5': '3 Szenen, wobei 2 kleine Szenen oben und 1 große Szene unten dargestellt sind',
	'PanAndZoomLayout6': 'Abfolge von 4 Szenen, die horizontal angeordnet sind',
	'pageSelectWarning': 'Szene auswählen.',
	'noSceneTransitionLabel': 'Ohne',
	'sceneTransitionPropertyLabel': 'Szenenübergang',
	'animatedPathSceneTransitionLabel': 'Animierter Pfad',
	'sweepSceneTransitionLabel': 'Schneller Übergang',
	'storyTypeLabel': 'Storytyp',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animation',
	'propAniAnimation': 'Animation',
	'propAniTypeEntrance': 'Eingangsanimation',
	'propAniDirectionIn': 'Eingangsrichtung',
	'propAniTypeExit': 'Ausgangsanimation',
	'propAniDirectionOut': 'Ausgangsrichtung',
	'propAniDirection': 'Richtung',
	'propAniEntrance': 'Eingangseffekt',
	'propAniTypeEntranceSlideIn': 'Hineinverschieben',
	'propAniTypeEntranceFadeIn': 'Einblenden',
	'propAniTypeEntrancePivotIn': 'Hineinschwenken',
	'propAniTypeEntranceScaleIn': 'Schrittweise einblenden',
	'propAniTypeEntranceShrinkIn': 'Einblenden und verkleinern',
	'propAniDirectionInLeft': 'Von links',
	'propAniDirectionInRight': 'Von rechts',
	'propAniDirectionInTop': 'Von oben',
	'propAniDirectionInBottom': 'Von unten',
	'propAniExit': 'Ausgangseffekt',
	'propAniTypeExitSlideIn': 'Hinausverschieben',
	'propAniTypeExitFadeIn': 'Ausblenden',
	'propAniTypeExitPivotOut': 'Hinausschwenken',
	'propAniTypeExitScaleIn': 'Schrittweise ausblenden',
	'propAniTypeExitExpandOut': 'Nach außen erweitern',
	'propAniDirectionOutLeft': 'Nach links',
	'propAniDirectionOutRight': 'Nach rechts',
	'propAniDirectionOutTop': 'Nach oben',
	'propAniDirectionOutBottom': 'Nach unten',
	'propAniEntranceTime': 'Beginn um (Sek):',
	'propAniExitTime': 'Ende um (Sek):',
	'animationNoEntranceText': 'Es findet keine Eingangsanimation statt, wenn sich das Widget am Anfang der Szene befindet.',
	'animationNoExitText': 'Es findet keine Ausgangsanimation statt, wenn sich das Widget am Ende der Szene befindet.',
	'propAniTypeDataEntrance': 'Eingang - Daten',
	'propAniRevealDuration': 'Dauer der Eingangsanimation',
	'timelineAnimationProperties': 'Animationseigenschaften öffnen',
	'scenesPropertiesSection': 'Szenen',
	'editStoryCoachMarkTitle': 'Story bearbeiten',
	'editStoryCoachMarkContents': 'Klicken Sie zum Bearbeiten dieser Story auf das Stiftsymbol.',
	'addDataStoryCoachMarkContents': 'Ziehen Sie Daten aus dem Datenfenster in die Story und legen Sie sie ab.',
	'expandSceneCoachmarkTitle': 'Zeitachse öffnen',
	'expandSceneCoachmarkContents': 'Szene durch Anpassen der Objektsichtbarkeit auf der Basis von Zeit und Dauern animieren.',
	'overviewCoachmarkTitle': 'Übersichtsszenen',
	'overviewCoachmarkContents': 'Mit den Übersichtsszenen am Anfang und Ende der Story können Sie einen allgemeinen Überblick über alle Szenen darstellen. In einer Übersichtsszene können Sie auf eine Szene klicken und diese an die gewünschte Position ziehen, um sie mit einer anderen Szene zu tauschen. Die Übersichtsszenen in den Eigenschaften der Story können ein- oder ausgeblendet werden.',
	'animatedPathCoachmarkTitle': 'Animierter Pfad',
	'animatedPathCoachmarkContents': 'Duplizieren Sie eine Szene mit einem Objekt, um den Übergang eines Objekts von einer Szene in eine andere zu animieren. In der neuen Szene können Sie das duplizierte Objekt verschieben, seine Größe verändern oder es drehen.',
	'propShowStoryOverviewFirstSlide': 'Alle Szenen am Anfang anzeigen',
	'propShowStoryOverviewLastSlide': 'Alle Szenen am Ende anzeigen',
	'storySceneSingleCountLabel': '1 Szene',
	'storySceneCountLabel': '%{count} Szenen',
	'storySceneRangeCountLabel': 'Szene %{index} von %{count}',
	'storySceneExpand': 'Zeitachse öffnen',
	'storySceneActionMenu': 'Menü mit Szenenoptionen öffnen',
	'timelineRightContainerLabel': 'Schaltflächengruppe für Zeitachse',
	'timelineViewLabel': 'Zeitachse',
	'timelineZoomFit': 'Automatisch zoomen',
	'timelineZoomIn': 'Vergrößern',
	'timelineZoomOut': 'Verkleinern',
	'timelinePositionIndicator': 'Positionsanzeiger der Zeitachse bei %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'Positionsanzeiger der Zeitachse nach links verschieben zu %{position}',
	'timelinePositionIndicatorMoveRightTo': 'Positionsanzeiger der Zeitachse nach rechts verschieben zu %{position}',
	'sceneStart': 'Zum Anfang der Szene bei %{position} springen',
	'sceneEnd': 'Zum Ende der Szene bei %{position} springen',
	'timelineHighlightTitle': 'Hervorheben',
	'addTimelineHighlight': 'Hervorhebung hinzufügen',
	'addSceneBtnTitle': 'Neue Szene mit Standardvorlage hinzufügen',
	'addSceneChevronBtnTitle': 'Szenenvorlage auswählen',
	'timelinePlay': 'Wiedergabe',
	'timelinePause': 'Anhalten',
	'sceneNavigation': 'Szenennavigation',
	'navNextScene': 'Nächste Szene',
	'navPrevScene': 'Vorherige Szene',
	'navPrevSceneAbbreviated': 'Vorherige Szene',
	'navExitFullScreen': 'Gesamtanzeigemodus beenden',
	'navToggleOverview': 'Übersicht ein-/ausschalten',
	'rowNumber': 'Zeile %{number}',
	'overviewBtnLabel': 'Übersicht',
	'sceneListStart': 'Übersicht - Start',
	'sceneListEnd': 'Übersicht - Ende',
	'timelineLeftHandle': 'Linker Ziehpunkt für %{name}',
	'timelineRightHandle': 'Rechter Ziehpunkt für %{name}',
	'timelineLeftHandleNoTitle': 'Linker Ziehpunkt',
	'timelineRightHandleNoTitle': 'Rechter Ziehpunkt',
	'timelineMoveLeft': '%{object} nach links verschieben',
	'timelineMoveRight': '%{object} nach rechts verschieben',
	'timelineMoveWidget': 'Zeitachsenwidget nach %{newStartTime} und %{newEndTime} verschoben',
	'timelineMoveWidgetStartTime': 'Startzeit für Zeitachsenwidget in %{newStartTime} geändert',
	'timelineMoveWidgetEndTime': 'Endzeit für Zeitachsenwidget in %{newEndTime} geändert',
	'timelineMoveWidgetDown': 'Zeitachsenwidget nach unten verschoben',
	'timelineMoveWidgetUp': 'Zeitachsenwidget nach oben verschoben',
	'addSceneTitle': 'Szene hinzufügen',
	'blankSceneLayout': 'Leer',
	'titleSceneLayout': 'Titel mit Untertitel',
	'sceneLayout1': 'Titel mit Text neben einer Visualisierung',
	'sceneLayout2': 'Titel mit einer Visualisierung',
	'sceneLayout3': 'Titel mit zwei Visualisierungen',
	'sceneLayout4': 'Verschiedene Verwendungsmöglichkeiten',
	'sceneLayout5': 'Kein Titel mit Text neben einer Visualisierung',
	'sceneLayout6': 'Verschiedene Verwendungsmöglichkeiten - 2 mal 2',
	'sceneLayout7': 'Verschiedene Verwendungsmöglichkeiten - 2 neben 1',
	'sceneLayout8': 'Verschiedene Verwendungsmöglichkeiten - 1 neben 2',
	'sceneLayout9': 'Verschiedene Verwendungsmöglichkeiten - 1 über 2',
	'sceneLayout10': 'Verschiedene Verwendungsmöglichkeiten - 2 über 1',
	'sceneLayout11': 'Verschiedene Verwendungsmöglichkeiten - 4 über 1',
	'sceneLayout12': 'Verschiedene Verwendungsmöglichkeiten - 1 über 1 neben 2 mal 2 über 1',
	'titleWidgetPlaceholderText': 'Titel hier eingeben',
	'subtitleWidgetPlaceholderText': 'Untertitel hier eingeben',
	'createStoryViewTitle': 'Story erstellen',
	'defaultStoryName': 'Neue Story',
	'screenshot_label': 'Story %{title}',
	'screenshot_label_scene': 'Szene %{sceneTitle} von Story %{title}',
	'filmstripHandleOpenLabel': 'Szenenauswahl öffnen',
	'filmstripHandleCloseLabel': 'Szenenauswahl schließen'
});
